import React, { useState, useEffect, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import SubItemComponent from './SubItemComponent';
import StoreAccordion from './FileAndTableAccordion/StoreAcordion';
import { dispatchSubContents } from 'redux/slicers/subCategoriesSlice';
import RelatedItems from 'components/common/RelatedItems';

const StoreSubCategoryWrapper = ({
  contentId,
  subCategories,
  subContentTree: subTree,
  relatedItems,
  popularData,
  content
}) => {
  const { subContents } = useSelector(state => state.subCategories);
  const dispatch = useDispatch();
  const [selectedKey, setSelectedKey] = useState(subCategories[0].id);
  useEffect(() => {
    getSubContents(subCategories, subTree);
  }, []);

  const changeKey = val => {
    setSelectedKey(val);
  };

  const getSubContents = async (subCategories, subTree) => {
    let tempSubContents = [];
    for (let index = 0; index < subCategories.length; index++) {
      const sub_branch = subCategories[index];

      const resSubContents = content;
      const sortedData = {};
      const historySubTree = subTree?.filter(item =>
        item?.startsWith('/history')
      );
      const documentsSubTree = subTree?.filter(item =>
        item?.startsWith('/documents')
      );

      const filteredSubTree = sub_branch.name.includes('Store Furniture')
        ? historySubTree
        : documentsSubTree;

      filteredSubTree?.length > 0 &&
        filteredSubTree.forEach(path => {
          sortedData[path] = {
            name: path.split('/')[path.split('/').length - 1],
            data: []
          };
        });

      if (Object.keys(sortedData).length > 0) {
        resSubContents.forEach(item => {
          if (sortedData['/' + item.pathISsmallplaintextbox]) {
            sortedData['/' + item.pathISsmallplaintextbox].data.push(item);
          }
        });
      }

      const nestedData = {};
      for (const [path, { name, data }] of Object.entries(sortedData)) {
        let parentData = [];
        let parentObj = nestedData;
        const pathParts = path.split('/').filter(part => part !== '');

        for (const [index, part] of pathParts.entries()) {
          if (index < pathParts.length - 1) {
            if (!parentObj[part]) {
              parentObj[part] = { name: part, data: [] };
            }
            parentData = parentObj[part].data;
            parentObj = parentObj[part];
          } else {
            parentObj[part] = { name, data };
          }
          if (parentObj['Popular Documents']) {
            parentObj['Popular Documents'].data = popularData;
          }
        }
      }
      const nestedSubContentData = Object.entries(nestedData).map(
        ([key, value]) => ({ [key]: value })
      );
      tempSubContents.push({
        _id: sub_branch.id,
        contents: nestedSubContentData
      });
    }

    dispatch(dispatchSubContents(tempSubContents));
  };

  const selectedSubContents = useMemo(() => {
    const subContentsLocal = [...subContents];
    const selected = subContentsLocal.find(item => item._id == 1);

    if (selected) {
      return selected.contents;
    }
    return [];
  }, [selectedKey, subContents]);

  return (
    <>
      <Row className="mb-4">
        {subCategories.map((s, index) => (
          <Col lg={subCategories.length === 2 ? 6 : 4} key={index}>
            <SubItemComponent
              {...s}
              selectedKey={selectedKey}
              changeKey={changeKey}
            />
          </Col>
        ))}
      </Row>
      {selectedSubContents?.length > 0 && selectedKey === 1 ? (
        <Row>
          <Col>
            <StoreAccordion data={selectedSubContents} contentId={contentId} />
          </Col>
        </Row>
      ) : (
        <RelatedItems relatedItems={relatedItems} isStore={true} />
      )}
    </>
  );
};

StoreSubCategoryWrapper.propTypes = {
  contentId: PropTypes.string,
  subCategories: PropTypes.array,
  subContentTree: PropTypes.array
};

export default StoreSubCategoryWrapper;
